// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2N7D0","containerItemsCenter":"Skeleton_containerItemsCenter__33aqP"};